import React, { createContext, useContext, useState, useEffect } from "react";
import { auth, db } from "../firebaseConfig/FirebaseConfig";
import { fetchUserData } from "../utils/paymentUtil";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubscribeUserDoc = null;

    const unsubscribeAuth = auth.onAuthStateChanged(async (firebaseUser) => {
      setLoading(true);

      try {
        if (firebaseUser) {
          const userData = await fetchUserData(firebaseUser);

          if (userData) {
            setUser(userData);

            // Set up a listener for changes in the user's Firestore document
            const userDocRef = db.collection("users").doc(userData.uid);

            unsubscribeUserDoc = userDocRef.onSnapshot((doc) => {
              if (doc.exists) {
                setUser((prevUser) => ({
                  ...prevUser,
                  ...doc.data(),
                })); // Merge Firestore changes into the user state
              }
            });
          } else {
            setUser(null); // Handle unexpected API response
          }
        } else {
          setUser(null); // Clear user state on logout
        }
      } catch (error) {
        console.error("Error fetching user data:", error.message);
        setUser(null); // Clear user state on error
      } finally {
        setLoading(false); // Stop loading state
      }
    });

    return () => {
      unsubscribeAuth(); // Cleanup auth listener
      if (unsubscribeUserDoc) unsubscribeUserDoc(); // Cleanup Firestore listener
    };
  }, []);

  return (
    <AuthContext.Provider value={{ user, loading, setLoading, setUser }}>
      {loading ? (
        <div className="flone-preloader-wrapper">
          <div className="flone-preloader">
            <span></span>
            <span></span>
          </div>
        </div>
      ) : (
        children
      )}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
